import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Code, Eye, Copy, LayoutList } from 'lucide-react';
import { StatusBadge } from '../components/StatusBadge';
import { useWorkspace } from '../contexts/WorkspaceContext';
import { PreviewModal } from '../components/PreviewModal';
import { FormPreview } from '../components/FormPreview';
export function SignupForms() {
  const {
    forms,
    duplicateForm
  } = useWorkspace();
  const [previewForm, setPreviewForm] = useState<(typeof forms)[0] | null>(null);
  return <div className="space-y-6" data-id="element-1794">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-1795">
        <div className="min-w-0" data-id="element-1796">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-1797">Signup Forms</h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-1798">
            Manage your custom HTML signup forms and embed codes.
          </p>
        </div>
        <Link to="/forms/new" className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 whitespace-nowrap flex-shrink-0" data-id="element-1799">
          <Plus className="h-4 w-4 flex-shrink-0" data-id="element-1800" />
          <span data-id="element-1801">Create Form</span>
        </Link>
      </div>

      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-1802">
        {forms.length === 0 ? <div className="p-12 text-center" data-id="element-1803">
            <LayoutList className="mx-auto h-12 w-12 text-gray-400" data-id="element-1804" />
            <h3 className="mt-2 text-sm font-semibold text-gray-900" data-id="element-1805">
              No forms created
            </h3>
            <p className="mt-1 text-sm text-gray-500" data-id="element-1806">
              Get started by creating a new signup form.
            </p>
          </div> : <div className="overflow-x-auto" data-id="element-1807">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-1808">
              <thead className="bg-gray-50" data-id="element-1809">
                <tr data-id="element-1810">
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1811">
                    Form Name
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1812">
                    Slug
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1813">
                    Status
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1814">
                    Last Updated
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1815">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-1816">
                {forms.map(form => <tr key={form.id} className="hover:bg-gray-50" data-id="element-1817">
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1818">
                      <div className="text-sm font-medium text-gray-900 truncate max-w-[200px]" data-id="element-1819">
                        {form.name}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1820">
                      <code className="text-xs bg-gray-100 px-2 py-1 rounded text-gray-600" data-id="element-1821">
                        {form.slug}
                      </code>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1822">
                      <StatusBadge status={form.status} data-id="element-1823" />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1824">
                      {form.updated}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-1825">
                      <div className="flex items-center justify-end gap-3" data-id="element-1826">
                        <button onClick={() => setPreviewForm(form)} className="text-gray-400 hover:text-blue-600 flex-shrink-0" title="Preview" data-id="element-1827">
                          <Eye className="h-4 w-4" data-id="element-1828" />
                        </button>
                        <Link to={`/forms/${form.id}/embed`} className="text-gray-400 hover:text-blue-600 flex-shrink-0" title="Get Embed Code" data-id="element-1829">
                          <Code className="h-4 w-4" data-id="element-1830" />
                        </Link>
                        <button onClick={() => duplicateForm(form.id)} className="text-gray-400 hover:text-blue-600 flex-shrink-0" title="Duplicate" data-id="element-1831">
                          <Copy className="h-4 w-4" data-id="element-1832" />
                        </button>
                        <Link to={`/forms/${form.id}`} className="text-blue-600 hover:text-blue-900 whitespace-nowrap" data-id="element-1833">
                          Edit
                        </Link>
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>}
      </div>

      <PreviewModal isOpen={!!previewForm} onClose={() => setPreviewForm(null)} title={`Preview: ${previewForm?.name}`} data-id="element-1834">
        {previewForm && <FormPreview html={previewForm.html} data-id="element-1835" />}
      </PreviewModal>
    </div>;
}